import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface InvestmentMandateTypeState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allInvestmentMandateType: [] | null | any;
}
const initialState: InvestmentMandateTypeState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allInvestmentMandateType: null,
};
export const investmentMandateTypeSlice = createSlice({
  name: 'InvestmentMandateType',
  initialState,
  reducers: {
    setAllInvestmentMandateType: (state, action) => {
      state.allInvestmentMandateType = action.payload.data;
    },
    setInvestmentMandateType: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllInvestmentMandateTypeBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllInvestmentMandateType, setInvestmentMandateType, setAllInvestmentMandateTypeBySearch,reset } = investmentMandateTypeSlice.actions;
export const allInvestmentMandateTypeDetails = (state: RootState) => state.investmentMandateType.allInvestmentMandateType;
export const getAllInvestmentMandateTypeDetails = (state: RootState) => state.investmentMandateType.data;
export const getInvestmentMandateTypeTotalRecords=(state:RootState)=>state.investmentMandateType.totalRecords;
export const getAllInvestmentMandateTypeBySearch = (state: RootState) => state.investmentMandateType.data;
export default investmentMandateTypeSlice.reducer;